import React from "react";
import {Alert} from "react-bootstrap";

const SuccessAlert = ({message}) => {
    return (
        <Alert variant="success">
            <div className="alert-message">
                <span className="block sm:inline">{message}</span>
            </div>
        </Alert>
)
}

export default SuccessAlert